export const roleLocalizationConfig = [
  'koor',
  'lirv',
  'lrma',
  'ownbt',
  'alfwn',
];


export const hasRoleLocalization = (): boolean => {
  return roleLocalizationConfig.includes(process.env.REACT_APP_BRAND);
}

export const toLocalKey = (label: string) => {
  return (
    label
      .toLowerCase()
      .trim()
      .replace(/['",.?/|]/g, '')
      .replace(/\s+/g, '_')
      .replace(/-+/g, '_')
  );
}
